module.exports = __webpack_public_path__ + "static/vertical_gradient-2ede08e79fad624fa40b7ad03b34183c.png";